import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { ChecklistItemNote } from "models/interfaces/checklist-item-notes/checklist-item-note";
import { ChecklistItemNoteSectionRecord } from "models/view-models/checklist-item-notes/checklist-item-note-section-record";
import { CollectionUtils } from "utilities/collection-utils";
import RichTextUtils from "utilities/rich-text-utils";

const defaultValues: ChecklistItemNote =
    RecordUtils.auditableDefaultValuesFactory<ChecklistItemNote>({
        checklistItemId: 0,
        checklistItemNoteSections: [],
        text: "",
    });

export class ChecklistItemNoteRecord
    extends Record(defaultValues)
    implements ChecklistItemNote
{
    constructor(params?: Partial<ChecklistItemNote>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (CollectionUtils.hasValues(params.checklistItemNoteSections)) {
            params.checklistItemNoteSections = RecordUtils.ensureRecords(
                params.checklistItemNoteSections,
                ChecklistItemNoteSectionRecord
            );
        }

        super(params);
    }

    public hasCodeReferences(): boolean {
        return CollectionUtils.hasValues(this.checklistItemNoteSections);
    }

    public hasContent(): boolean {
        return this.hasText() || this.hasCodeReferences();
    }

    public hasText(): boolean {
        return RichTextUtils.hasValue(this.text);
    }

    public with(values: Partial<ChecklistItemNote>): ChecklistItemNoteRecord {
        return new ChecklistItemNoteRecord(Object.assign(this.toJS(), values));
    }
}
